import React from 'react'
import { InjectHtml } from '@/components/ui'
import { messages } from './messages'
import './styles.scss'

export const NotAvailableServiceSign: React.FC = () => {
  return (
    <div className="notAvailableServiceSignWrapper">
      <InjectHtml textId={messages.sign} />
    </div>
  )
}
